/** Copyright © 2013-2023 DataYes, All Rights Reserved. */

import React from 'react';
import user from 'utils/user';
import { showLoginModal, showRegisterModal } from '../login-register';
import Nav from './components/nav/index';
import DownloadApp from './components/download';
import Us from './components/us';
import HeaderUser from './components/user';
import SubNav from './components/sub-nav';
import logo from './images/logo.png';
import { navs, ROBO_URL } from './config';
import { getActiveNav, formatUser } from './utils';
import { StyledHeader } from './style';

const { mainNavKey, key, ...rest } = getActiveNav(navs);

export default function GlobalHeader({ userInfo }: { userInfo: Record<string, string> }) {
  const info = formatUser({ user: userInfo });

  return (
    <>
      <StyledHeader>
        <a href={ROBO_URL} className="header-logo">
          {!!Object.keys(userInfo).length && <img src={info?.tenantLogo || logo} alt="Robo" />}
        </a>
        <Nav navs={navs} activeKey={mainNavKey} />
        <DownloadApp />
        <Us />
        <HeaderUser
          {...info}
          logout={user.logout}
          showLoginModal={showLoginModal}
          showRegisterModal={showRegisterModal}
        />
      </StyledHeader>
      <SubNav userInfo={userInfo} mainKey={key} {...rest} />
    </>
  );
}
